<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-bottom:20px;">Acknowledgement</h1>
<p style="text-indent:0em !important;">I am indebted to the late Japanese historical novelist, Eiji Yoshikawa, whose retelling of Japanese historical classics in his own style, provided the inspiration to write this book.</p><br/>
<p style="text-indent:0em !important;">My gratitude also to Martin Bridgewater, whose invaluable advice and feedback guided my hand in polishing the manuscript. A special thanks to the Simpson family for their support and finally, my gratitude to the Publishers Austin Macauley for allowing me to bring this story to life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?9be3a502